import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { Feature } from "@omni/types/api/product/bff/shared/feature.model";

import { Translate } from "@/redux/modules/value/translations/translations.provider";
import { displayFeature } from "@/utils/features/display";

import { FeatureCodes } from "../paintConfigurator.types";

export const OTHER_FEATURE_VALUE = "other";

const toDisplayValue = (
    t: Translate,
    feature: Feature | undefined,
    name?: string
) => {
    if (!feature) {
        return {
            name: name || t("paintConfigurator.feature.other.name"),
            value: OTHER_FEATURE_VALUE
        };
    }
    return {
        name: name || feature.name,
        value: displayFeature({
            formattedValues: feature.featureValues.map(
                (fv) => fv.formattedValue || ""
            ),
            unitName: feature.unit?.name
        })
    };
};

export const getFeature = (
    t: Translate,
    product: Product<ProductFieldSet.Full>,
    featureCode: FeatureCodes,
    name?: string
) => {
    const feature = product.features?.find((f) => f.code === featureCode);

    return toDisplayValue(t, feature, name);
};
